import React from 'react'
import { useFormContext, Controller } from 'react-hook-form'

import Input from './input'

const TextInput = ({
  title = '',
  type = 'text',
  name,
  defaultValue = '',
  rules = {},
  onBlur: onBlurProp,
  ...props
}) => {
  const { control } = useFormContext()
  return (
    <Controller
      rules={rules}
      control={control}
      render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => (
        <Input
          className={props.className}
          // Controller consumes `name`, so without forwarding it the rendered
          // input has no name attribute at all — invalid HTML, and it leaves
          // HubSpot's collected-forms capture with nothing to identify the
          // field by, so it falls back to scraping surrounding text.
          name={name}
          onChange={onChange}
          // field.onBlur marks the field as touched, which is what the form's
          // onTouched mode validates on — without forwarding it no error ever
          // renders. Any consumer handler runs first so value normalisation
          // (trimming) is applied before validation reads the value.
          onBlur={(event) => {
            onBlurProp?.(event)
            onBlur()
          }}
          value={value}
          error={error}
          title={title}
          type={type}
          {...props}
        />
      )}
      name={name}
      defaultValue={defaultValue}
    />
  )
}

export default TextInput
